import dayjs from "dayjs";
import { MONTHS_ENUM } from "../../common/Constants";
import { ComplianceActivityStatus } from "../../../constants/Compliance.constants";
import { getValue } from "../../../utils/common";
import { CentralId, RuleTypeEnum } from "../Masters/Master.constants";

export function getNoticePayload(data: any) {
    const {
        act,
        activity,
        approverDueDate,
        associate_company,
        auditedDate = "0001-01-01T00:00:00",
        auditRemarks = '',
        auditStatus = '',
        auditted,
        company,
        complianceManager,
        complianceOwner,
        day = 1,
        department,
        dueDate,
        formsStatusRemarks = '',
        id,
        issuedAuthority = '',
        issuedDepartment = '',
        location,
        month = MONTHS_ENUM[new Date().getMonth()],
        noticeDate = "0001-01-01T00:00:00",
        noticeDescription = '',
        noticeDueDate = "0001-01-01T00:00:00",
        rule,
        ruleCompliance,
        savedDate = "0001-01-01T00:00:00",
        startDate = dayjs(new Date()).startOf('D').local().format(),
        status = ComplianceActivityStatus.DUE,
        submittedDate = "0001-01-01T00:00:00",
        uploadNotice = '',
        veritical,
        year = new Date().getFullYear(),
    } = data;

    return {
        act_id: act.value,
        activity_id: activity.value,
        act_state_mapping_id: ruleCompliance.id,
        approver_due_date: dayjs(approverDueDate).startOf('D').local().format(),
        associate_company_id: associate_company.value,
        audited_date: auditedDate,
        audit_remarks: auditRemarks,
        audit_status: auditStatus,
        auditted: auditted.value,
        company_id: company.value,
        compliance_manager_id: complianceManager ? complianceManager.value : null,
        compliance_owner_id: complianceOwner ? complianceOwner.value : null,
        day,
        department_id: department ? department.value : null,
        due_date: dayjs(dueDate).startOf('D').local().format(),
        forms_status_remarks: formsStatusRemarks,
        id,
        is_notice: true,
        issued_authority: issuedAuthority,
        issued_department: issuedDepartment,
        location_id: location.value,
        month,
        notice_date: dayjs(noticeDate).startOf('D').local().format(),
        notice_description: noticeDescription,
        notice_due_date: dayjs(noticeDueDate).startOf('D').local().format(),
        published: false,
        rule_id: rule.value,
        saved_date: savedDate,
        start_date: startDate,
        status,
        submitted_date: submittedDate,
        upload_notice: uploadNotice,
        veritical_id: veritical ? veritical.value : null,
        year,
    }
}

export function getNoticeData(data: any) {
    const {
        act,
        activity,
        act_state_mapping,
        approver_due_date,
        associate_company,
        audited_date,
        audit_remarks,
        audit_status,
        auditted,
        company,
        compliance_manager,
        compliance_owner,
        day,
        department,
        due_date,
        forms_status_remarks,
        id,
        issued_authority,
        issued_department,
        location,
        month,
        notice_date,
        notice_description,
        notice_due_date,
        rule,
        rule_compliance,
        saved_date,
        start_date,
        status,
        submitted_date,
        upload_notice,
        veritical,
        year,
        file
    } = data;
    return {
        act: { value: act.id, label: act.name, act },
        activity: { value: activity.id, label: activity.name, activity },
        approverDueDate: new Date(approver_due_date),
        associate_company: { value: associate_company.id, label: associate_company.name, associate_company },
        auditedDate: audited_date,
        auditRemarks: audit_remarks,
        auditStatus: audit_status,
        auditted: { value: auditted, label: auditted },
        company: { value: company.id, label: company.name, company },
        complianceManager: compliance_manager ? { value: compliance_manager.id, label: compliance_manager.name } : null,
        complianceOwner: compliance_owner ? { value: compliance_owner.id, label: compliance_owner.name } : null,
        day,
        department: department ? { value: department.id, label: department.name } : null,
        dueDate: new Date(due_date),
        establishment_type: { value: act.establishment_type, label: act.establishment_type },
        formsStatusRemarks: forms_status_remarks,
        id,
        issuedAuthority: issued_authority,
        issuedDepartment: issued_department,
        location: { value: location.id, label: location.name, location },
        state_id: getValue(act_state_mapping, 'state_id'),
        month,
        noticeDate: new Date(notice_date),
        noticeDescription: notice_description,
        noticeDueDate: new Date(notice_due_date),
        rule: { value: rule.id, label: rule.name, rule },
        ruleCompliance: act_state_mapping,
        savedDate: saved_date,
        startDate: start_date,
        status,
        submittedDate: submitted_date,
        type: (act_state_mapping && act_state_mapping.state_id === CentralId) ?
            { value: RuleTypeEnum.CENTRAL, label: RuleTypeEnum.CENTRAL } :
            { value: RuleTypeEnum.STATE, label: RuleTypeEnum.STATE },
        uploadNotice: upload_notice,
        veritical: veritical ? { value: veritical.id, label: veritical.name } : null,
        year,
        file
    }
}
